// extracted by mini-css-extract-plugin
export default {"selectedTimelight":"tag_selectedTimelight__UlE4B","selectedTimedark":"tag_selectedTimedark__ulRS3","btnView":"tag_btnView__jEJx0"};